<template>
    <!--<div ref="formRef" class="form-seplag p-grid p-fluid" >-->
        <form ref="formRef" class="form-seplag p-grid p-fluid">
            <slot></slot>
        </form>
    <!--</div>-->
</template>

<script>
export default {
    name: 'FormSeplag',
    data() {
        return {
            msgErros: []
        }
    },
    methods: {
        validarCPF(cpf) {	
            cpf = cpf.replace(/[^\d]+/g,'');
            let add = 0;	
            let rev = 0;		
            if(cpf == '') return false;	
            // Elimina CPFs invalidos conhecidos	
            if (cpf.length != 11 || 
                cpf == "00000000000" || 
                cpf == "11111111111" || 
                cpf == "22222222222" || 
                cpf == "33333333333" || 
                cpf == "44444444444" || 
                cpf == "55555555555" || 
                cpf == "66666666666" || 
                cpf == "77777777777" || 
                cpf == "88888888888" || 
                cpf == "99999999999")
                    return false;		
            // Valida 1o digito	
            for (let i=0; i < 9; i ++)		
                add += parseInt(cpf.charAt(i)) * (10 - i);	
                rev = 11 - (add % 11);	
                if (rev == 10 || rev == 11)		
                    rev = 0;	
                if (rev != parseInt(cpf.charAt(9)))		
                    return false;		
            // Valida 2o digito	
            add = 0;	
            for (let i = 0; i < 10; i ++)		
                add += parseInt(cpf.charAt(i)) * (11 - i);	
            rev = 11 - (add % 11);	
            if (rev == 10 || rev == 11)	
                rev = 0;	
            if (rev != parseInt(cpf.charAt(10)))
                return false;		
            return true;   
        },
        validar() {
            // Limpa o campo de mensagem de erros
            this.msgErros = []
            // Carrega os campos Obrigatórios
            let camposObrigatorios = this.$refs.formRef.querySelectorAll('[required]')
            // Percorre a array de campos obrigatórios
            for(var campo of camposObrigatorios) {
                // Verifica se o campo está vazio
                if (!campo || campo.value == ''){
                    //campo.setAttribute('class', campo.getAttribute('class')  +' p-error')
                    campo.classList.add('p-error');
                    this.msgErros.push('O campo "' + campo.name + '" deve ser preenchido!',);

                }else if(campo.className.split(/\s+/)[0] == 'p-selectbutton'){
                    let element = campo.getElementsByTagName("div");
                    let check = false;
                    for(let i=0; i< element.length; i++){
                        if(element[i].getAttribute("aria-pressed")){
                            check = true;
                        }
                    }
                    if(!check){
                        campo.classList.add('p-error');
                        this.msgErros.push('O campo "' + campo.getAttribute("name") + '" deve ser Selecionado!',);
                    }else{
                        // Remove a classe p-error do campo
                        campo.classList.remove('p-error')
                    }

                }else if(campo.className.split(/\s+/)[0] == 'p-calendar'){
                    let input = campo.getElementsByTagName("input")[0];                    
                    if(!input.disabled){   
                        if(input.value == ''){
                            campo.classList.add('p-error')
                            this.msgErros.push('O campo "' + input.name + '" deve ser Selecionado!',);
                        }else{
                            // Remove a classe p-error do campo
                            campo.classList.remove('p-error')
                        }
                    }

                }else if(campo.className.split(/\s+/)[0] == 'p-dropdown'){  
                    if(!campo.getElementsByTagName('input')[0].disabled){         
                        let label = campo.getElementsByTagName("span")[0];
                        let classLabel = label.className.split(/\s+/);
                        let i = 0;
                        for(i; i < classLabel.length; i++){
                            if(classLabel[i]=='p-placeholder'){                                
                                campo.classList.add('p-error')
                                this.msgErros.push('O campo "' + campo.getAttribute("name") + '" deve ser Selecionado!',);
                                break;
                            }
                        }
                        if(i>classLabel.length){
                            // Remove a classe p-error do campo
                            campo.classList.remove('p-error')
                        }
                    }
                    
                } else {  
                    // Remove a classe p-error do campo
                    campo.classList.remove('p-error')
                }
            }
            let elementCPF = document.getElementsByName("CPF")[0]
            if(elementCPF){
                if(!this.validarCPF(elementCPF.value)){
                    if(!elementCPF.classList.contains("p-error")){
                        elementCPF.classList.add('p-error');
                    }
                    this.msgErros.push('CPF Invalido!',);
                }

            }
            // Se não existe erro retorna true, caso contrário retorna o erro ao usuário
            if(this.msgErros.length > 0){
                return true;
            }else{
                return true;
            }
        }
    }
}
</script>

<style scoped>

</style>